import * as constActions from './const';
import initialState from './initialState';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.UPDATE_SUPPORTED_FEATURES: {
      let feature = action.feature;
      if (action.scanGroupId) {
        feature += `_${action.scanGroupId}`;
      }
      let supportedByHostsFeaturesCopy = Object.assign({}, state[feature], action.featuresSupport);
      let retVal = Object.assign({}, state, {
        [feature]: supportedByHostsFeaturesCopy
      });
      return retVal;
    }
    default:
      return state;
  }
}
